import React, { useEffect, useState } from 'react'
import CoursesList from './CoursesList'
import SetPage from '../../data/SetPage'
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import ModalStyle from '../../data/ModalStyle'
import Close from '@mui/icons-material/Close'
import { PlayCircle } from '@mui/icons-material'
import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';
import img from "../../assets/images/connection/avatar10.jpg"
import img2 from "../../assets/images/coursehero.png"

const OfflineCourses = () => {

  useEffect(() => {
    SetPage("Offline Courses")
    window.scrollTo(0, 0)
  }, [])

  const [demo, setdemo] = useState(false)

  return (
    <div className="pb-5 mb-5">

      <Helmet>
        <title>SiliconMinds - Offline Courses | Offline Training Programs</title>
        <meta name="description" content="Learn In-Person at our institute with our Offline Courses: Hands-On Learning, Personalized Instruction, and Real-World Skills Training Await You!" />
      </Helmet>

      {/* MODAL – UNCHANGED */}
      <Modal open={demo} onClose={() => setdemo(false)}>
        <Box sx={ModalStyle} className="col-lg-4 col-md-5 br-5 col-sm-6 col-11 p-2">
          <div className="d-flex justify-content-between">
            <h4>Introduction</h4>
            <Close className="text-danger" type="button" onClick={() => setdemo(false)} />
          </div>
          <Typography sx={{ mt: 2 }}>
            <video
              className="w-100"
              poster="https://skillsuprise.com/data/images/offline-training-poster.png"
              autoPlay
              controls
              src="https://skillsuprise.com/data/videos/offline-demo.mp4"
            />
          </Typography>
        </Box>
      </Modal>

      {/* 🔥 NEW HERO DESIGN (BACKEND SAME) */}
      <section className="su-hero-new h-90vh">

        <div className="container">
          <div className="row align-items-center min-vh-75 py-5">

            {/* LEFT CONTENT (BACKEND SAME TEXT + BUTTON LOGIC) */}
            <div className="col-lg-6 text-white mt-4">
              <div className="su-hero-left">

                <div className="su-pill">
                  <span className="ping-dot"></span>
                  CLASSROOM-BASED LEARNING
                </div>

                <h1 className="su-hero-title mt-3">
                  Offline <span>Training</span> Programs with Industry <span>Experts</span>
                </h1>

                <p className="su-hero-sub fs-5 pt-3">
                  Learn in-person at our institute with hands-on training,
                  personalized mentorship, and real-world skill development.
                </p>

                {/* <button
                  onClick={() => setdemo(true)}
                  className="btn su-cta-btn mt-4"
                >
                  <PlayCircle className="me-2" />
                  Watch Demo
                </button> */}

                <div className="su-stats mt-4">
                  <div>
                    <h4 className="text-warning">10K+</h4>
                    <p>Learners</p>
                  </div>
                  <div>
                    <h4 className="text-info">150+</h4>
                    <p>Classroom Courses</p>
                  </div>
                  <div>
                    <h4 className="text-light">50+</h4>
                    <p>Expert Trainers</p>
                  </div>
                </div>

              </div>
            </div>

            {/* RIGHT CARD (ONLY UI CHANGED) */}
            <div style={{ marginTop: "30px" }} className="col-lg-6 text-center mt-sm-3 mt-lg-0 ">
              <div className="su-hero-card-wrap">

                <div className="su-hero-card">
                  <img src={img2} alt="Course" />

                  <div className="su-card-footer">
                    <div>
                      <strong>Offline </strong>
                      <span>Training</span>
                    </div>
                    <div>
                      <strong>6000+ </strong>
                      <span>Students</span>
                    </div>
                  </div>
                </div>

                <div className="su-glow"></div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* SKILLSUPRISE COMPONENT – UNCHANGED */}
      <div className="container sm-p-0">
        <CoursesList mode={"offline"} />
      </div>

      {/* 🎨 INTERNAL CSS – DESIGN ONLY */}
      <style>{`
        .su-hero-new {
          background:
            linear-gradient(to bottom, rgba(2,6,23,.75), rgba(2,6,23,.95)),
            url("https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=2000");
          background-size: cover;
          background-position: center;
          // border-radius: 0 0 40px 40px;
        }

        .su-pill {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 6px 14px;
          border-radius: 50px;
          background: rgba(59,130,246,.15);
          border: 1px solid rgba(96,165,250,.4);
          color: #f2f4f7;
          font-size: 11px;
          letter-spacing: .12em;
          margin-bottom: 14px;
        }

        .ping-dot {
          width: 8px;
          height: 8px;
          background: #fafafb;
          border-radius: 50%;
        }

        .su-hero-title {
          font-size: 48px;
          font-weight: 900;
          line-height: 1.1;
        }

        .su-hero-title span {
          background: linear-gradient(90deg, #fd834a, #fa9165);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .su-hero-sub {
          color: #cbd5f5;
          max-width: 520px;
        }

        .su-cta-btn {
          background: linear-gradient(135deg, #ff8145, #fb895c);
          color: #fff;
          border-radius: 999px;
          padding: 12px 32px;
          font-weight: 700;
          border: none;
        }

        .su-stats {
          display: flex;
          gap: 40px;
          flex-wrap: wrap;
        }

        .su-stats p {
          font-size: 12px;
          color: #cbd5f5;
          margin: 0;
        }

        .su-hero-card-wrap {
          position: relative;
          max-width: 460px;
          margin: auto;
        }

        .su-hero-card {
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 25px 60px rgba(0,0,0,.4);
        }

        .su-hero-card img {
          width: 100%;
          height: 320px;
          object-fit: cover;
        }

        .su-card-footer {
          display: flex;
          justify-content: space-around;
          padding: 12px;
          background: linear-gradient(90deg, #fe8247, #fa8f64);
          color: white;
        }

        .su-card-footer span {
          font-size: 11px;
          letter-spacing: 1px;
          text-transform: uppercase;
        }

        .su-glow {
          position: absolute;
          inset: -10%;
          background: rgba(99,102,241,.2);
          filter: blur(120px);
          z-index: -1;
        }

        @media (max-width: 992px) {
          .su-hero-title { font-size: 34px; }
          .su-hero-card img { height: 240px; }
          .su-stats { gap: 20px; }
        }
      `}</style>
    </div>
  )
}

export default OfflineCourses